import { render, staticRenderFns } from "./CalendarEventCreatePopover.vue?vue&type=template&id=0f041059"
import script from "./CalendarEventCreatePopover.vue?vue&type=script&lang=js"
export * from "./CalendarEventCreatePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports